import { Injectable } from '@angular/core';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { LisRatesRequestPayload } from '../interfaces/lis-rates.request.interface';
import { LISRateObj, LISRatesResponsePayload, LISRateByYear } from '../interfaces/lis-rates-payload.interface';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { EffectiveDateStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/effective-date.state-structure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LisRatesService {

  constructor(
    private httpClient: HTTPWrapperContext,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  getLisRates(currentYear: number, nextYear: number): Promise<LISRatesResponsePayload> {
    const zipCountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');

    const aspId = environment.initData.brand.ASPID;
    const market = 'Senior';
    const year = [currentYear, nextYear];
    const county = zipCountyState.county && zipCountyState.county.county;
    const region = zipCountyState.county && zipCountyState.county.region;

    const ratesRequestPayload: LisRatesRequestPayload = {
      aspId, market, year, county, region
    };

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: '/lis/rates',
      POST_OR_PUT_PAYLOAD: ratesRequestPayload
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.GOOGLE_CLOUD);
    return this.httpClient.makeRequest<LISRatesResponsePayload>(requestConfig);
  }
}
